import { render, staticRenderFns } from "./Html1.vue?vue&type=template&id=5c97f35b&scoped=true&"
import script from "./Html1.vue?vue&type=script&lang=js&"
export * from "./Html1.vue?vue&type=script&lang=js&"
import style0 from "./Html1.vue?vue&type=style&index=0&id=5c97f35b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97f35b",
  null
  
)

export default component.exports